import * as React from "react";
import AsphaltDropdown, { AsphaltDropdownProps } from "@asphalt-react/dropdown";
import { InputLabel } from "src/components/Input";
import { Box } from "src/components/Box";
import { Text } from "../Text";

type Props = {
  label?: React.ReactNode;
  helperText?: string;
  error?: boolean;
} & AsphaltDropdownProps;

export const Dropdown: React.FC<Props> = (props: Props) => {
  const { label, helperText, error, ...asphaltProps } = props;
  return (
    <Box>
      {label && <InputLabel>{label}</InputLabel>}
      <AsphaltDropdown {...asphaltProps} invalid={error} />
      {helperText && (
        <Text
          marginTopS
          fontSize="small"
          color={error ? "danger" : undefined}
          fontWeight="book"
        >
          {helperText}
        </Text>
      )}
    </Box>
  );
};

Dropdown.defaultProps = {
  size: "s",
  stretch: true,
};
